import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1b38de8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "info cm-ui-mt10" }
const _hoisted_4 = {
  class: "row",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  class: "row",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "row" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "info cm-ui-mt10" }
const _hoisted_11 = { class: "sub-row" }
const _hoisted_12 = { class: "desc cm-ui-ml5" }
const _hoisted_13 = { class: "sub-row" }
const _hoisted_14 = { class: "desc cm-ui-ml5" }
const _hoisted_15 = { class: "sub-row" }
const _hoisted_16 = { class: "desc cm-ui-ml5" }
const _hoisted_17 = { class: "sub-row" }
const _hoisted_18 = { class: "desc cm-ui-ml5" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "info cm-ui-pt10" }
const _hoisted_22 = {
  key: 0,
  class: "row"
}
const _hoisted_23 = { class: "rb-btn" }
const _hoisted_24 = { class: "drawer-wrapper" }
const _hoisted_25 = ["src"]
const _hoisted_26 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_MixSelectors = _resolveComponent("MixSelectors")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_ContentAdaptLayout, { class: "container" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("label", {
            class: "row-label",
            title: _ctx.t('groupPolicySettings.examEnableScheduled')
          }, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('groupPolicySettings.examEnableScheduled')), 1)
          ], 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.strategy.main_switch,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.strategy.main_switch) = $event)),
              onChange: _ctx.setChangeStatus
            }, null, 8, ["modelValue", "onChange"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", {
            class: "row-label",
            style: {"padding":"0"},
            title: _ctx.t('groupPolicySettings.schedFreqLabel')
          }, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('groupPolicySettings.schedFreqLabel')), 1)
          ], 8, _hoisted_5),
          _createVNode(_component_el_select, {
            size: "small",
            modelValue: _ctx.strategy.frequency,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.strategy.frequency) = $event)),
            disabled: !_ctx.strategy.main_switch,
            onChange: _ctx.changeFrequency
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                type: 1,
                label: _ctx.t('softwareDisabledEdit.freqDaily'),
                value: 1
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                type: 2,
                label: _ctx.t('softwareDisabledEdit.freqWeekly'),
                value: 2
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                type: 3,
                label: _ctx.t('softwareDisabledEdit.freqMonthly'),
                value: 3
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue", "disabled", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", {
            class: "row-label",
            title: _ctx.t('groupPolicySettings.schedTimeLabel')
          }, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('groupPolicySettings.schedTimeLabel')), 1)
          ], 8, _hoisted_7),
          _createVNode(_component_MixSelectors, {
            "main-switch": _ctx.strategy.main_switch,
            "mix-type": _ctx.strategy.frequency,
            "s-key": "regularExamSelectors"
          }, null, 8, ["main-switch", "mix-type"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", {
            class: "row-label",
            title: _ctx.t('groupPolicySettings.examTaskExecMode')
          }, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('groupPolicySettings.examTaskExecMode')), 1)
          ], 8, _hoisted_9),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_col, { onChange: _ctx.setChangeStatus }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_el_radio, {
                    disabled: !_ctx.strategy.main_switch,
                    class: "type-radio",
                    modelValue: _ctx.strategy.task_type,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.strategy.task_type) = $event)),
                    modelModifiers: { number: true },
                    label: _ctx.ExaminationTaskTypes.OnlyRemind
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.examOnlyRemind')), 1),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.t('groupPolicySettings.avOnlyRemindDesc')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "modelValue", "label"]),
                  _createVNode(_component_el_link, {
                    disabled: !_ctx.strategy.main_switch,
                    type: "primary",
                    class: "link cm-ui-mtz5",
                    underline: false,
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.handlerShowDialogDemo(true)), ["prevent"]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.dialogDemoPopupTitle')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_el_radio, {
                    disabled: !_ctx.strategy.main_switch,
                    class: "type-radio",
                    modelValue: _ctx.strategy.task_type,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.strategy.task_type) = $event)),
                    modelModifiers: { number: true },
                    label: _ctx.ExaminationTaskTypes.RemindLaterExaminationAndRepair
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.examRemindForce3m')), 1),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.t('groupPolicySettings.avRemindForce3mDesc', { clientName: _ctx.brandConfig.client_name })), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "modelValue", "label"]),
                  _createVNode(_component_el_link, {
                    disabled: !_ctx.strategy.main_switch,
                    type: "primary",
                    class: "link cm-ui-mtz5",
                    underline: false,
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.handlerShowDialogDemo(false)), ["prevent"]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.dialogDemoPopupTitle')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_el_radio, {
                    disabled: !_ctx.strategy.main_switch,
                    class: "type-radio",
                    modelValue: _ctx.strategy.task_type,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.strategy.task_type) = $event)),
                    modelModifiers: { number: true },
                    label: _ctx.ExaminationTaskTypes.DonotRemindAndExamination
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.examSilentNoRepair')), 1),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t('groupPolicySettings.avSilentScanNoRepairDesc')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "modelValue", "label"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_el_radio, {
                    disabled: !_ctx.strategy.main_switch,
                    class: "type-radio",
                    modelValue: _ctx.strategy.task_type,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.strategy.task_type) = $event)),
                    modelModifiers: { number: true },
                    label: _ctx.ExaminationTaskTypes.DonotRemindExaminationAndRepair
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.examSilentRepair')), 1),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.t('groupPolicySettings.avSilentScanRepairDesc', { clientName: _ctx.brandConfig.client_name })), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "modelValue", "label"])
                ])
              ]),
              _: 1
            }, 8, ["onChange"])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("label", {
            class: "row-label",
            title: _ctx.t('groupPolicySettings.examTargetTitle')
          }, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('groupPolicySettings.examTargetTitle')), 1)
          ], 8, _hoisted_20),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_el_space, {
              size: 10,
              direction: "vertical",
              alignment: "flex-start",
              onChange: _ctx.setChangeStatus
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  disabled: !_ctx.strategy.main_switch,
                  class: "type-radio",
                  modelValue: _ctx.strategy.interval_type,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.strategy.interval_type) = $event)),
                  modelModifiers: { number: true },
                  label: _ctx.IntervalTypes.Unlimited
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.avUnlimited')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue", "label"]),
                _createVNode(_component_el_radio, {
                  disabled: !_ctx.strategy.main_switch || _ctx.strategy.regular_tasks.length > 1,
                  class: "type-radio",
                  modelValue: _ctx.strategy.interval_type,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.strategy.interval_type) = $event)),
                  modelModifiers: { number: true },
                  label: _ctx.IntervalTypes.MoreThanOneDay
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.examNotExam1d')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue", "label"]),
                _createVNode(_component_el_radio, {
                  disabled: !_ctx.strategy.main_switch || _ctx.strategy.regular_tasks.length > 1,
                  class: "type-radio",
                  modelValue: _ctx.strategy.interval_type,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.strategy.interval_type) = $event)),
                  modelModifiers: { number: true },
                  label: _ctx.IntervalTypes.MoreThanThreeDay
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.examNotExam3d')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue", "label"]),
                _createVNode(_component_el_radio, {
                  disabled: !_ctx.strategy.main_switch || _ctx.strategy.regular_tasks.length > 1,
                  class: "type-radio",
                  modelValue: _ctx.strategy.interval_type,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.strategy.interval_type) = $event)),
                  modelModifiers: { number: true },
                  label: _ctx.IntervalTypes.MoreThanSevenDay
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.examNotExam7d')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue", "label"])
              ]),
              _: 1
            }, 8, ["onChange"])
          ])
        ]),
        (_ctx.operateType !== _ctx.OperateType.read)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_el_button, {
                  class: "cm-ui-ml10",
                  size: "small",
                  type: "primary",
                  onClick: _ctx.handlerSave,
                  disabled: !_ctx.data.hasEdit && _ctx.operateType !== _ctx.OperateType.add && 0
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('common.save')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: _ctx.cancel
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('common.cancel')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.dialogDemoVisible,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dialogDemoVisible) = $event)),
      title: _ctx.t('groupPolicySettings.dialogDemoPopupTitle'),
      "destroy-on-close": "",
      size: 400
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          (_ctx.data.allExamTip)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.allExamImage,
                alt: "tip",
                width: "390"
              }, null, 8, _hoisted_25))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _ctx.threeMinExamImage,
                alt: "tip"
              }, null, 8, _hoisted_26))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}